import { Route, Routes } from 'react-router-dom';
import { RoomDetailPage } from '../pages/rooms/RoomDetailPage';
import RoomsMainPage from '../pages/rooms/RoomsMainPage';

export const RoomRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<RoomsMainPage />} />
            <Route path="/detail/:roomid" element={<RoomDetailPage />} />
        </Routes>
    );
};
